import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { useMediaQuery } from 'react-responsive';

import { breakpointDown } from '../../../../services/responsive/responsive';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  children: PropTypes.func,
};

const PhotoGridViewerActionButton = ({
  className,
  label,
  icon,
  onClick,
  children,
  forceMobileMode = false,
  ...props
}) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));
  const useMobileUI = isMobile || forceMobileMode;

  const classes = classNames({
    'photo-grid-viewer-action-button': true,
    'dropdown-item': useMobileUI,
    [className]: !!className,
  });

  if (typeof children === 'function') {
    return <>{children({ className: classes, isMobile: useMobileUI })}</>;
  }

  return (
    <button
      className={classes}
      data-tip={label}
      data-for={label}
      data-position="bottom"
      onClick={onClick}
      {...props}
    >
      {icon}
      <span className={useMobileUI ? 'ml-1' : 'sr-only'}>{label}</span>
      {!useMobileUI && <ReactTooltip id={label} className="tooltip" />}
    </button>
  );
};

PhotoGridViewerActionButton.propTypes = propTypes;

export default PhotoGridViewerActionButton;
